import { BaseModel } from "model/BaseModel";
import Auditoria from "./Auditoria";
import ItemClasseAuditoria from "./ItemClasseAuditoria";

export default class ClasseAuditoria implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    notaMaxima: number;
    notaFinal: number;
    auditoria: Auditoria;
    itensAuditoria: ItemClasseAuditoria[];

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        notaMaxima = 0,
        notaFinal = 0,
        auditoria = new Auditoria(),
        itensAuditoria = []
    ){
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.notaMaxima = notaMaxima;
        this.notaFinal = notaFinal;
        this.auditoria = auditoria;
        this.itensAuditoria = itensAuditoria;
    }

}